import { Button, InputBaseComponentProps, ListItem, ListItemText, Switch } from "@mui/material";
import React from "react";

interface SwitchFormListItemProps {
    text: string,
    initialValue: boolean,
    onSave?: (value: boolean) => void
    inputProps?: InputBaseComponentProps,
}

const SwitchFormListItem: React.FC<SwitchFormListItemProps> = ({
    text,
    initialValue,
    onSave,
}) => {
    const [value, setValue] = React.useState(initialValue)

    React.useEffect(() => {
        setValue(initialValue)
    }, [initialValue])

    return (
        <ListItem>
            <ListItemText primary={text} />
            <Switch
                checked={value}
                color="secondary"
                onChange={e => {
                    setValue(e.target.checked)
                }}
            />
            <Button
                variant="outlined"
                sx={{ marginLeft: "1em" }}
                onClick={() => {
                    if (onSave) {
                        onSave(value)
                    }
                }}
            >保存</Button>
        </ListItem>
    );
}

export default SwitchFormListItem